(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/overrides/product/fulltraff.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/overrides/product/fulltraff.js');
"use strict";


const newEnetpulseWidgets = svs.core.detect.feature('ft-enetpulse-new');
const _svs$components$sport = svs.components.sportinfo.common,
  MatchState = _svs$components$sport.matchState.SportinfoMatchState,
  _svs$components$sport2 = _svs$components$sport.constants,
  SportinfoPathNames = _svs$components$sport2.SportinfoPathNames,
  SportradarWidgets = _svs$components$sport2.SportinfoSportradarWidgets,
  EnetPulseViewType = _svs$components$sport2.EnetPulseViewType,
  EnetpulseColorThemes = _svs$components$sport2.EnetpulseColorThemes,
  SvsViewType = _svs$components$sport2.SvsViewType;
const _svs$components$sport3 = svs.components.sportinfo.common.constants,
  ContentProvider = _svs$components$sport3.ContentProvider,
  EnetpulseWidgets = _svs$components$sport3.EnetpulseWidgets;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfoFulltraff,
      provider: ContentProvider.Svs
    }]).prepend(MatchState.Ongoing, [{
      type: SportradarWidgets.LiveMatchTracker,
      provider: ContentProvider.SportRadar
    }]);
  }).addTab(SportinfoPathNames.Statistic, tab => {
    tab.set(MatchState.NotStarted, [{
      type: SportradarWidgets.HeadToHead,
      provider: ContentProvider.SportRadar,
      viewProps: {
        components: ['form', 'lastmatches']
      }
    }]).setMany([MatchState.Ongoing, MatchState.Finished], [{
      type: SportradarWidgets.Scoreboard,
      provider: ContentProvider.SportRadar,
      title: 'Matchhändelser',
      viewProps: {
        disableWidgetHeader: true,
        disableMatchInfo: true,
        expandedGoalScorers: true
      }
    }, {
      type: SportradarWidgets.GeneralStatistics,
      provider: ContentProvider.SportRadar,
      title: 'Livestatistik'
    }]).prependAll([{
      provider: ContentProvider.PlayMakerGoal,
      viewProps: {
        isXstat: false
      }
    }]);
  }).addTab(SportinfoPathNames.PlayMakerXstat, tab => {
    tab.setAll([{
      type: SvsViewType.PlayMakerXstat,
      provider: ContentProvider.PlayMakerXstat,
      viewProps: {
        isXstat: true
      }
    }]);
  }).addTab(SportinfoPathNames.Mutuals, tab => {
    tab.setMany([MatchState.Ongoing, MatchState.NotStarted], [{
      type: SportradarWidgets.MatchPreview,
      provider: ContentProvider.SportRadar,
      viewProps: {
        disableMoreStats: true,
        disableExpandButton: true
      }
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.Table, tab => {
    tab.setAll([{
      type: SportradarWidgets.LiveTable,
      provider: ContentProvider.SportRadar,
      viewProps: {
        showOnlySelectedGroup: true
      }
    }]);
  }).addTab(SportinfoPathNames.Lineup, tab => {
    tab.setAll([{
      type: SportradarWidgets.MatchLineups,
      provider: ContentProvider.SportRadar
    }]);
  }).setDefaultRoutes(SportinfoPathNames.Statistic, [MatchState.Finished]).build(),
  menuItems = _ConfigBuilder$addTab.menuItems,
  content = _ConfigBuilder$addTab.content,
  defaultRoutes = _ConfigBuilder$addTab.defaultRoutes;
const _ConfigBuilder$addTab2 = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfoFulltraff,
      provider: ContentProvider.Svs
    }]).prepend(MatchState.Ongoing, [{
      type: SportradarWidgets.LiveMatchTracker,
      provider: ContentProvider.SportRadar
    }]);
  }).addTab(SportinfoPathNames.Statistic, tab => {
    tab.set(MatchState.NotStarted, [{
      type: EnetPulseViewType.HeadToHead,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.HeadToHead,
      viewProps: {
        options: {
          lng: 'sv',
          el_limit: 5,
          sh_h2h_s_f: 'yes',
          h2h_sh_m: 'yes'
        }
      }
    }, {
      type: EnetPulseViewType.WinProbability,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.WinProbability,
      viewProps: {
        hasMultipleWidgets: true,
        options: {
          lng: 'sv'
        }
      }
    }]).setMany([MatchState.Ongoing, MatchState.Finished], [{
      type: EnetPulseViewType.MatchIncidents,
      provider: ContentProvider.EnetPulse,
      title: 'Matchhändelser',
      widgetId: EnetpulseWidgets.MatchIncidents,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]).prependAll([{
      provider: ContentProvider.PlayMakerGoal,
      viewProps: {
        isXstat: false
      }
    }]);
  }).addTab(SportinfoPathNames.PlayMakerXstat, tab => {
    tab.setAll([{
      type: SvsViewType.PlayMakerXstat,
      provider: ContentProvider.PlayMakerXstat,
      viewProps: {
        isXstat: true
      }
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.Table, tab => {
    tab.setAll([{
      type: EnetPulseViewType.TournamentStandings,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.TournamentStandings,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]);
  }).addTab(SportinfoPathNames.Lineup, tab => {
    tab.setAll([{
      type: EnetPulseViewType.MatchFormations,
      provider: ContentProvider.EnetPulse,
      widgetId: EnetpulseWidgets.MatchFormations,
      vviewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]);
  }).setDefaultRoutes(SportinfoPathNames.Statistic, [MatchState.Finished]).build(),
  enetpulseMenuItems = _ConfigBuilder$addTab2.menuItems,
  enetpulseContent = _ConfigBuilder$addTab2.content,
  enetpulseDefaultRoutes = _ConfigBuilder$addTab2.defaultRoutes;
setGlobal('svs.components.sportinfo.configs.sportConfigs.productOverrides', {
  fulltraffConfig: newEnetpulseWidgets ? {
    menuItems: enetpulseMenuItems,
    content: enetpulseContent,
    defaultRoutes: enetpulseDefaultRoutes,
    config: 'fulltraff' 
  } : {
    menuItems,
    content,
    defaultRoutes,
    config: 'fulltraff' 
  }
});

 })(window);